import { FormControl, InputLabel, Select, Box, MenuItem, useMediaQuery } from "@mui/material";
import { OptionWithImage } from "src/components/projetos/types";
import { resolveProtocolUrl } from "src/store/global.store";
import theme from "src/theme/light";

interface CustomSelectProps {
  id: string;
  label: string;
  value: OptionWithImage<string | number> | null;
  onChange: (value: { name?: string | undefined; value: unknown; image: string; }) => void;
  options: OptionWithImage<string | number>[]
  disabled?: boolean;
}

const MenuProps = {
  PaperProps: {
    style: {
      minWidth: 400,
      minHeight: 'auto',
    },
  },
}

const MenuPropsMobile = {
  PaperProps: {
    style: {
      minWidth: '100%',
      minHeight: 'auto',
      marginLeft: 16,
    },
  },
}

function SelectWithImageInOption({ id, label, value, onChange, options, disabled = false }: CustomSelectProps) {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <FormControl
      disabled={!options.length || disabled}
      fullWidth
      variant="outlined"
      size={"small"}
    >
      <InputLabel shrink={!!value} id={`${id}-label`} style={{ backgroundColor: "#fff", padding: "0px 1px" }}>
        {label}
      </InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value || ''} 
        renderValue={() => {
          return (
            <Box display="flex" alignItems={"center"} justifyContent="flex-start">
              <img style={{ width: '35px', height: 'auto' }} src={resolveProtocolUrl(value?.image)} alt={value?.text}/>
              <Box component="span" ml={2}>{value?.text}</Box>
            </Box>
          )
        }}
        MenuProps={isMobile ? MenuPropsMobile : MenuProps}>
        {options.map((option) => (
          <MenuItem onClick={() => onChange(option)} key={option.value} value={option.value}>
            <Box display="flex" alignItems={"center"} justifyContent="flex-start">
              <img style={{ width: '35px', height: 'auto' }} src={resolveProtocolUrl(option.image)} alt={option.text}/>
              <Box component="span" ml={2} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{option.text}</Box>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export { SelectWithImageInOption };